import { useEffect, useState } from "react";
import { execSeatableSql } from './seatable.js';
import { Modal, Button } from 'react-bootstrap';
import AllImg from './allimg.js';
import AllMarkdown from './allmarkdown.js';
import Faq from './faq.js';

function TopHeader(props) {
    const [loading, setLoading] = useState(false);
    const [showMarkdown, setShowMarkdown] = useState(false);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM \`PageContent\` WHERE \`Menu Level\` IN ('${props.MenuLevel}') ORDER BY \`Rank\``;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          const rowData = rows && rows.results;
          setData(rowData);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.MenuLevel]); 

    function handleButtonClick(e) {
        const url = e.currentTarget.dataset.url;
        const title = e.currentTarget.dataset.title;

        setLoading(true);
        setSelectedTitle(title);
        setSelectedUrl(url);
        setShowMarkdown(true);
    }

    return (<>
        <div id="top" className='mt-5 section-header d-flex flex-column nav-margin'>
            {(data && (data.length > 0)) ? (<>
                {data.map((row, index) => {return (<>
                    <div key={index} id={row["Menu Item"]} className="mx-3 d-flex flex-column flex-md-row justify-content-center" style={{paddingTop: "125px", marginTop: "-125px"}}>
                        {row["fnMediaLink"] ? (
                        <div className="mx-3 col-11 col-md-3 d-flex justify-content-center align-items-center">
                            <AllImg className="my-3 img-fluid" src={row["fnMediaLink"]} alt={row["Menu Item"]} />
                        </div>
                        ) : ''}
                        <div className="mt-3" data-aos="fade-right" data-aos-delay="100">
                            <div className="section-sub-title lato-light">
                                <AllMarkdown>{row["About"]}</AllMarkdown>
                            </div>
                        </div>
                    </div>
                    {row["ButtonText"] ? (
                        <div className="py-3 d-flex justify-content-center align-items-center">
                            <Button id={`btn-${row["Menu Item"]}`} onClick={handleButtonClick} data-title={row["ButtonText"]} data-url={row["ButtonLink"]} style={{zIndex: "990"}}>{row["ButtonText"]}</Button>
                        </div>
                    ) : ''}
                    {(row["Menu Item"] === 'FAQs') ? (
                        <Faq />
                    ) : ''}
                </>)})}
            </>) : ''}
        </div>
        <Modal size="xl" show={showMarkdown} onHide={() => setShowMarkdown(false)} centered style={{zIndex: "99999"}}>
            <Modal.Header closeButton>
            <div className="d-flex flex-row">
                <img className="my-auto" src="/favicon-16x16.png" alt="Allteam" />
                <div className="mx-2 my-auto" style={{textTransform: 'uppercase', letterSpacing: '0.1rem'}}>{selectedTitle}</div>
            </div>
            </Modal.Header>
            <Modal.Body style={{height: "80vh"}}>
                {loading ? (
                    <div className="spinner-grow loader-iframe" role="status"></div>
                ) : ''}
                <iframe title={selectedTitle} src={selectedUrl} width="100%" height="100%" onLoad={() => setLoading(false)} ></iframe>
            </Modal.Body>
        </Modal>
    </>)
}

export default TopHeader;